import moment from 'moment';

const getFullDate = function (dateTime) {
  const date = moment(dateTime, 'YYYY-MM-DD HH:mm').toDate();

  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (hours < 10) hours = `0${hours}`;
  if (minutes < 10) minutes = `0${minutes}`;

  const fulldate = `${day}.${month + 1}.${year} ${hours}:${minutes}`;

  return fulldate;
};

export { getFullDate };
